import React, { useState } from "react";
import { createGlobalStyle } from "styled-components";
import Appbackground from "./img/denim.png";
import { Chrono } from "react-chrono";
import buildAllAvailableItems from "./data";

const GlobalStyle = createGlobalStyle`
  html {
    background: center fixed url(${Appbackground});
  }
  header {
    display: flex,
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
    flex-direction: column;
    font-size: calc(10px + 1vmin);
  }
`;

function App() {

  const [allItems] = useState(buildAllAvailableItems());

  const daysLeft = 0//allItems.find((item) => item.locked).num + 1;
  const latestItem = 98//allItems.findIndex((item) => item.locked ?? 100) - 1;
  console.log("daysLeft", daysLeft);
  console.log("latestItem", latestItem);
  console.log("allitems", allItems);

  return (
    <>
      <GlobalStyle />
      <header>
        <h1>Calendrier de l'avant-retraite</h1>
        {/* <h2>Plus que {daysLeft} jour{daysLeft > 1 ? 's':''} : Bientôt l'acquis !</h2> */}
        <h2>TERMINÉ !!!</h2>
      </header>
      <div className="calendrier">
        <Chrono mode="HORIZONTAL" items={allItems} allowDynamicUpdate focusActiveItemOnLoad toolbarPosition="bottom"   /*disableToolbar*/
        parseDetailsAsHTML activeItemIndex={allItems.length-1} highlightCardsOnHover itemWidth={175}
        enableDarkToggle lineWidth={6} timelinePointShape="circle" timelinePointDimension={50}
        theme={{secondary: 'blue', titleColorActive: 'white'}} buttonTexts={{first: "Début", last: "Fin", next: "Suivant", previous: "Précédent"}}
        titleDateFormat="DD.MM.YYYY" contentDetailsHeight={200} mediaSettings={{ align: 'center', imageFit:'contain' }} slideShow slideItemDuration={15000}>
          <div className="chrono-icons">
            {allItems.map((jour, key) => <strong className={(jour.num < daysLeft ? "locked" : (jour.num === daysLeft ? "latest" : "" ))}>{jour.num}</strong>)}
          </div>
        </Chrono>
      </div>

    </>
  );
}

export default App;
